import WebLayout from "../layout/WebLayout";

function Investor() {
  return (
    <WebLayout pageName={Investor}>
      <div className="product-dContent__box">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-description"
            role="tabpanel"
            aria-labelledby="pills-description-tab"
            tabIndex="0">
            <div className="text-center">
              <h4 className="text-2xl mb-2">
                Investment Opportunity in IndianMSME.org
              </h4>
              <h5 className="text-xl">
                Empowering MSMEs | Enabling Growth | Building Bharat
              </h5>
            </div>
            <hr></hr>
            <div className="mb-20">
              <h6 className="mb-10">About IndianMSME.org</h6>
              <p className="mb-2">
                IndianMSME.org “from Makers to Markets” is a pioneering digital
                B2B platform committed to empowering all manufacturers including
                Micro, Small & Medium Enterprises (MSMEs) across India. We
                bridge the gap between manufacturers and retails channels
                through a robust digital ecosystem — including the exclusive 800
                Districts Ardh Sainik Mall DDC Network (One District – One DDC
                Model).
              </p>
              <h6 className="mt-10 mb-10">Why Invest in IndianMSME.org?</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Nationwide Reach – Target of 800+ District Ardh Sainik Mall
                  DDCs C&F franchise across India.
                </li>
                <li>
                  Scalable & Sustainable Model – Tech-driven supply chain +
                  Franchise revenue streams.
                </li>
                <li>
                  First-Mover Advantage – Monopoly-based district franchise
                  model with manufacturer linkage.
                </li>
                <li>
                  Backed by Government Schemes – Aligned with Atmanirbhar
                  Bharat, Startup India, and Make in India.
                </li>
                <li>
                  Diverse Revenue Channels – Franchise fees, product
                  commissions, B2B supply chain margins, display and storage
                  income, marketing partnerships.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">Investment Scope</h6>
              <ul>
                <li>
                  <ul className="mt-10">
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Category: Early-Stage Impact Tech & Distribution for
                          retail
                        </span>
                      </div>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Use of Funds: Tech upgradation, logistics
                          partnerships, district onboarding, marketing
                        </span>
                      </div>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Return Model: Revenue-sharing / Equity-based /
                          Convertible Instruments
                        </span>
                      </div>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Exit Options: Franchise buybacks, strategic
                          partnerships, public-private expansion
                        </span>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
              <h6 className="mt-10 mb-10">Vision</h6>
              <p className="mb-10">
                To build India’s largest digital and physical MSME marketplace,
                empowering manufacturers including small businesses to compete,
                scale, and thrive with ease in 800 Districts.{" "}
              </p>
              <h6 className="mt-10 mb-10">Let’s Partner in Growth</h6>
              <p className="mb-10">
                If you're an impact investor, angel, or institutional fund
                looking to be part of India’s next big MSME revolution — let’s
                connect.
              </p>
              <em>📩 home@ardhsainik.com</em> &nbsp;
              <em>📞 +91-9971713965</em>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default Investor;
